import { ConcreteEncodable } from "./ConcreteEncodable";

import { HolidayCalendarRequestImplEncoder } from "../../encoder/HolidayCalendarRequestImplEncoder";

import * as CubiqTS from "../../index";
import { HolidayCalendarRequest } from "../HolidayCalendarRequest";

export class HolidayCalendarRequestImpl
  extends ConcreteEncodable
  implements HolidayCalendarRequest
{
  public static enType: string = "com.bcdfx.model.calendar.HolidayCalendarRequestImpl";

  /*FID=1*/
  public baseCcyCd: string;
  /*FID=2*/
  public nonBaseCcyCd: string;
  /*FID=3*/
  public product: CubiqTS.Product;
  /*FID=4*/
  public relativeToTime: CubiqTS.StandardTime | null = null;
  /*FID=5*/
  public relativeToDate: CubiqTS.StandardDate | null = null;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = HolidayCalendarRequestImplEncoder.Instance;
    this.setEncodableType(HolidayCalendarRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "HolidayCalendarRequestImpl[" +
      "baseCcyCd=" +
      this.baseCcyCd +
      "nonBaseCcyCd=" +
      this.nonBaseCcyCd +
      "product=" +
      this.product +
      "relativeToTime=" +
      this.relativeToTime +
      "relativeToDate=" +
      this.relativeToDate +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
